export default __webpack_public_path__ + "static/Volcano-boarding-7f9c7253db478bf5795a5604c1a62874.jpg";